import React from 'react';
import { useSchoolInfo } from '../hooks/useSchoolInfo';

export default function LocationMap({ className = "", showHeader = false }) {
  const schoolInfo = useSchoolInfo();
  return (
    <section className={`w-full relative ${className}`}>
      {showHeader && (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-6 sm:mb-8">
          <h3 className="text-2xl sm:text-3xl font-bold text-[#1D2923] font-serif-heading">
            Find vej til skolen
          </h3>
          <p className="text-sm sm:text-base text-[#5A6961] mt-1">
            {schoolInfo.address}, {schoolInfo.city}
          </p>
        </div>
      )}

      {/* Full-width Map Container */}
      <div className="relative w-full h-[380px] sm:h-[460px] lg:h-[520px] bg-[#eef4e6] border-y border-[#d9e5d4] overflow-hidden">
        {/* Map iframe with black and white / monochrome styling */}
        <iframe
          title="Odder Lille Friskole Kort"
          src="https://maps.google.com/maps?q=Randlevvej+4,+8300+Odder&t=&z=15&ie=UTF8&iwloc=&output=embed"
          className="w-full h-full border-0 filter grayscale contrast-[1.15] brightness-[0.95]"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />

        {/* Floating Info Badge positioned neatly over map */}
        <div className="absolute top-4 left-4 sm:top-6 sm:left-6 md:left-8 lg:left-12 max-w-xs bg-white/95 backdrop-blur-xs p-4 sm:p-5 rounded-2xl shadow-md border border-[#d9e5d4] text-xs sm:text-sm">
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 rounded-full bg-[#1D2923] text-white flex items-center justify-center shrink-0">
              <i className="fa-solid fa-location-dot text-xs" aria-hidden="true" />
            </div>
            <div>
              <h4 className="font-bold text-[#1D2923] text-sm">{schoolInfo.name}</h4>
              <p className="text-[#5A6961] mt-0.5">{schoolInfo.address}, {schoolInfo.city}</p>
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=Randlevvej+4,+8300+Odder"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 mt-2.5 font-bold text-[#1D2923] hover:text-black transition-colors"
              >
                <span>Find vej på Google Maps</span>
                <i className="fa-solid fa-arrow-up-right-from-square text-[10px]" aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
